import { useMemo } from 'react';
import { useIsAutorizedUser } from 'store/features/auth';
import { useUserPermissions } from 'entities/user';

export const useShowADRClasses = () => {
  const isAutorizedUser = useIsAutorizedUser();
  const permissions = useUserPermissions();

  return useMemo(() => ({
    showInBuildingRouteFilter: isAutorizedUser && permissions.locatorProAccess
  }), [isAutorizedUser, permissions]);
};
